import script from "./WCStickyAlertRoot.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCStickyAlertRoot.vue?vue&type=script&setup=true&lang=ts"

import "./WCStickyAlertRoot.vue?vue&type=style&index=0&id=06da2ed1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06da2ed1"]])

export default __exports__